module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRAISE FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("Four and Twenty Blackbirds")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("“Southern Gothic at its best. An absorbing mystery told with humor and bite.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—Kelley Armstrong, author of "), _c('em', [_vm._v("Industrial Magic")]), _vm._v(" and the Otherworld series")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("“Cherie Priest has created a chilling page-turner in her debut novel. Her voice is rich, earthy, soulful, and deliciously Southern as she weaves a disturbing yarn like a master! Awesome—gives you goose bumps!”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—L. A. Banks, author of "), _c('em', [_vm._v("Minion")]), _vm._v(" and The Vampire Huntress Legend series")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("“Breathlessly readable, palpably atmospheric, and compellingly suspenseful, "), _c('em', [_vm._v("Four and Twenty Blackbirds")]), _vm._v(" is a considerable debut. It’s written with great control and fluency, and it looks like the start of quite a career.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—Ramsey Campbell, World Horror Grand Master")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_c('em', [_vm._v("“Four and Twenty Blackbirds")]), _vm._v(" is a rare bird, the novel you wish you’d written yourself—excellent!”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—C. J. Henderson, author of "), _c('em', [_vm._v("The Things That Are Not There")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("“Wonderful. Enchanting. Amazing and original fiction that will satisfy that buttery Southern taste, as well as that biting aftertaste of the dark side. I loved it.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—Joe R. Lansdale, Stoker- and Edgar-winning author of "), _c('em', [_vm._v("The Bottoms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("“Cherie Priest has mastered the art of braiding atmosphere, suspense, and metaphysics into a resonant ghost story that offers even more than what you hope for.”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—Katherine Ramsland, author of "), _c('em', [_vm._v("Ghost: Investigating the Other Side")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_c('em', [_vm._v("“Four and Twenty Blackbirds")]), _vm._v(" is an extraordinary first novel—heck, it’s an extraordinary novel, period. It’s a ghost story and a voodoo mystery—and like any good Southern Gothic, it has a healthy obsession with race and inbreeding. But "), _c('em', [_vm._v("Blackbirds")]), _vm._v(" is more than the sum of its traditional parts. Cherie Priest’s writing, while decidedly capable of giving you the creeps, is infused with a refreshing spunkiness and interesting, believable characters. . . . Fans of supernatural horror should keep an eye on Cherie Priest!”")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—SciFiDimensions.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 57
// module chunks = 0